const deploy = {
    deployEnvironment: 'production',
    deployVersion: 'main-184',
};

export default deploy;
